import * as stylex from "@stylexjs/stylex";
import type { CalendarEvent, Tag, TagColor } from "@/domain/schemas";
import { eventColor, whoLabel } from "@/domain/tags";
import "@/theme/tokens.stylex";
import { colors, motion, radii, space } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { PersonDot } from "./PersonDot";
import { press } from "./press";
type AllDayTileProps = {
  label: string;
  title: string;
  who: string;
  location?: string;
  dot: TagColor | "soft";
  onClick: () => void;
};
const styles = {
  tile: {
    kMzoRj: "xc342km",
    kVVagm: "xln7xf2",
    kkrTdU: "x1ypdohk",
    k9WMMc: "x1yc453h",
    kAzted: "xbktkl8",
    kzqmXN: "xh8yej3",
    kB7OPa: "x9f619",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "xddi9bj",
    k8WAf4: "x10dr8xq",
    kg3NbH: "xw3ndq7",
    kaIpWk: "x1fv5t7x",
    kWkggS: "x5r8ks9",
    kMwMTN: "x1a11ngh",
    k1ekBW: "x11xpdln",
    kIyJzY: "x1bpocu2",
    kAMwcw: "x1em5f5i",
    $$css: true
  }
};
type AllDayTilesProps = {
  events: readonly CalendarEvent[];
  tags: readonly Tag[];
  label: string;
  everyoneLabel: string;
  onOpenEvent: (event: CalendarEvent) => void;
};
export function AllDayTile({
  label,
  title,
  who,
  location,
  dot,
  onClick
}: AllDayTileProps) {
  return <button type="button" onClick={onClick} {...stylex.props(styles.tile, press.scale)}>
      <span className="x2lah0s xr0iwhn xif65rj xkv8mnm xtvhhri xuxw1ft">{label}</span>
      <PersonDot color={dot} />
      <span className="x78zum5 xdt5ytf x195vfkc xeuugli">
        <span className="xosj86m xfbjfs5 x1yrajzq x132q4wb x1fzhlzt">{title}</span>
        <span className="x14c3fy2 x1dld7ex">{location ? `${who} · ${location}` : who}</span>
      </span>
    </button>;
}
export function AllDayTiles({
  events,
  tags,
  label,
  everyoneLabel,
  onOpenEvent
}: AllDayTilesProps) {
  if (events.length === 0) return null;
  return <div className="x78zum5 xdt5ytf x152posx">
      {events.map(event => <AllDayTile key={event.id} label={label} title={event.title} who={whoLabel(event, tags, everyoneLabel)} location={event.location} dot={eventColor(event, tags)} onClick={() => onOpenEvent(event)} />)}
    </div>;
}